/* -----------------------------------------
   設定
----------------------------------------- */
const SHOP_URL = "https://testr6b1.myshopify.com";
const STOREFRONT_TOKEN = "7002005c1eb9a66f33ddcfdc04a7d968";

/* -----------------------------------------
   GraphQL fetch
----------------------------------------- */
async function sfFetch(query, variables = {}) {
  const res = await fetch(`${SHOP_URL}/api/2024-10/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });
  return res.json();
}

/* -----------------------------------------
   全キャラの metaobject を取得
----------------------------------------- */
async function getAllCharacters() {
  const QUERY = `
    query GetCharacters($after: String) {
      metaobjects(type: "character", first: 100, after: $after) {
        edges {
          node {
            id
            handle

            image: field(key: "image") {
              reference { ... on MediaImage { image { url altText } } }
            }

            collection: field(key: "collection") {
              reference { ... on Collection { handle title } }
            }

            fields { key value }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  let results = [];
  let after = null;

  while (true) {
    const json = await sfFetch(QUERY, { after });
    const block = json.data.metaobjects;

    const mapped = block.edges.map(e => {
      const f = {};
      e.node.fields.forEach(v => (f[v.key] = v.value));

      return {
        title: f.title,
        image: e.node.image?.reference?.image,
        collection: e.node.collection?.reference,
        fields: f
      };
    });

    results.push(...mapped);

    if (!block.pageInfo.hasNextPage) break;
    after = block.pageInfo.endCursor;
  }

  return results;
}

/* -----------------------------------------
   normalize（比較用）
----------------------------------------- */
function normalize(str) {
  return str?.trim()?.replace(/[\u2010-\u2015]/g, "-")?.toLowerCase();
}

/* -----------------------------------------
   お気に入りブランドと一致するキャラだけ抽出
----------------------------------------- */
async function getFavoriteBrandCharacters(favoriteBrands) {
  const all = await getAllCharacters();
  return all.filter(char =>
    favoriteBrands.some(f => normalize(f) === normalize(char.title))
  );
}

/* -----------------------------------------
   属性 → 背景クラス
----------------------------------------- */
function getZokuseiClass(z) {
  switch (z) {
    case "火": return "bg-fire";
    case "水": return "bg-water";
    case "土": return "bg-earth";
    case "光": return "bg-light";
    case "闇": return "bg-dark";
    default: return "bg-default";
  }
}
